var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds-ellipsis"},[_c('div',{style:({'background': _vm.color})}),_vm._v(" "),_c('div',{style:({'background': _vm.color})}),_vm._v(" "),_c('div',{style:({'background': _vm.color})}),_vm._v(" "),_c('div',{style:({'background': _vm.color})})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-237bc1a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingIndicator.vue
// module id = null
// module chunks = 